import React from 'react';
import { ItemModel, ReassuranceModel } from '@/models';
import { useAppDispatch } from '@/redux';
import { toggleReassuranceModal } from '@/redux/slices/gui.slice';
import { CallToActionKind } from '@/types';
import { getAttributeId } from '@/utils/productUtils';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import Icon from '@/components/common/iconedLinks/Icon';

import styles from './ReassuranceMobile.module.scss';
import { DESIGN_SYSTEM_SIZES } from '@/constants/styles';

type ReassuranceMobileProps = {
  reassurances: ReassuranceModel[];
  currentItem: ItemModel;
  alertPrimeur: string;
}

const ReassuranceMobile = ({ reassurances, currentItem, alertPrimeur }: ReassuranceMobileProps): React.JSX.Element => {
  const dispatch = useAppDispatch();

  const openReassurance = (reassurance) => {
    dispatch(toggleReassuranceModal({ opened: true, reassurance }));
  };

  return reassurances && (
    <div className={styles.container}>
      {reassurances.map((reassurance) => {
        if (!reassurance.inStockToExcluded?.includes(getAttributeId(currentItem, 'in_stock')) &&
        !reassurance.inStockToExcluded?.includes(alertPrimeur)) {
          return (
            <div key={reassurance.logoLink} className={styles.item}>
              <Icon
                src={reassurance?.logoLink}
                alt={reassurance?.logoAlt}
                id={reassurance?.logoAlt}
                lazy
              />
              <CallToActionContainer
                kind={CallToActionKind.GHOST}
                buttonSize={DESIGN_SYSTEM_SIZES.SMALL}
                type="button"
                onClick={() => openReassurance(reassurance)}
                fullWidthOnMobile={false}
              >
                {reassurance?.title}
              </CallToActionContainer>
            </div>
          );
        }
      })}
    </div>
  );
};

export default ReassuranceMobile;
